<template>
<div class="card-item"
  :id="item.itemId">
  <div class="card-item-heading">{{ item.heading }}</div>
  <div class="card-item-content">
    <div class="experience">
      <div class="control">
        <RadioGroup v-model="item.data.experienceStatus">
          <Radio label="inexperience">{{ $planConfig.experienceStatusList.inexperience }}</Radio>
          <Radio label="continuation">{{ $planConfig.experienceStatusList.continuation }}</Radio>
          <Radio label="quit">{{ $planConfig.experienceStatusList.quit }}</Radio>
        </RadioGroup>
        <div class="input-item"
          v-if="item.data.experienceStatus !== 'inexperience'">
          <label for="">事業内容</label>
          <Input class="input"
            type="text"
            placeholder="事業内容"
            v-model="item.data.businessContents" />
        </div>
        <div class="input-item"
          v-if="item.data.experienceStatus === 'quit'">
          <label for="">やめた時期</label>
          <my-date v-bind:date="item.data.stopDate" />
        </div>
      </div>
    </div>
  </div>
</div>
</template>

<script>
export default {
  data() {
    return {}
  },
  props: ['item'],
  computed: {},
  mounted: function () {},
  methods: {}
}
</script>
